import React from "react";
import { Link } from 'react-router-dom';

import { whereBallsMove } from "../../helper";

class NoMatch extends React.Component {
    componentDidMount() {
        document.title = 'Fixfact';
        whereBallsMove(5);
    }

    render() {
        return (
            <div className="vertical-scrolling page firstSection sectionHome" id="sectionHome" data-main-nav-id="homeNavLink">
                <div className="container content">
    
                    <div className="left-content left-content-width error-block">
                        <h1>Fix<span className="text_gradient_violet">Fact</span></h1>
                        <ul className="main-advantages">
                            <li>Ошибка 404</li>
                            <li>Страница не найдена</li>
                        </ul>
                        <Link className="" to="/">
                            <button className="error-btn">
                                На главную страницу
                            </button>
                        </Link>
                    </div>
                </div>
            </div>
        )
    }
}

export default NoMatch


// WEBPACK FOOTER //
// ./src/components/Commons/NoMatch.js